
import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


const filter = {
	GrnOpenDate: null as Date | null,
	GrnClosedDate : null as Date | null,
	OrganizationIds: [] as number [],
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		OrganizationId: [],
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			VALUE: { isEditable: true, required: true },
		},
	},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
